import { render, staticRenderFns } from "./ExpressInfo.vue?vue&type=template&id=4cdcd5f7&scoped=true&"
import script from "./ExpressInfo.vue?vue&type=script&lang=js&"
export * from "./ExpressInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdcd5f7",
  null
  
)

export default component.exports